import * as React from 'react';

import type {ColorName} from '../colors/colors';
import {EntityPill} from './entity-pill';

type Props = {
    value: any;
    sublabel?: string | React.ReactNode;
    onRemove?: (value: any) => any;
    type?: string;
    colorName?: ColorName;
    tooltipText?: string | null | undefined;
};

export function EntityPillSelectWrapperSmall(props: Props) {
    const handleRemove = () => {
        if (typeof props.onRemove === 'function') {
            props.onRemove(props.value);
        }
    };

    return (
        <EntityPill
            {...props.value}
            sublabel={props.sublabel}
            type={props.type}
            isSmall={true}
            onRemove={props.onRemove ? handleRemove : undefined}
            colorName={props.colorName}
        />
    );
}
